// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.5H16.5V6.5H22V12.2547C20.8662 11.4638 19.4872 11 18 11C14.134 11 11 14.134 11 18C11 19.275 11.3409 20.4704 11.9365 21.5H2V6.5H7.5V2.5ZM9.5 6.5H14.5V4.5H9.5V6.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5 18C12.5 14.9624 14.9624 12.5 18 12.5C21.0376 12.5 23.5 14.9624 23.5 18C23.5 21.0376 21.0376 23.5 18 23.5C14.9624 23.5 12.5 21.0376 12.5 18ZM20.4142 19.0001L19 17.5857V15.752H17V18.4141L18.9999 20.4142L20.4142 19.0001Z"}}]};

const WorkHistoryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'work-history-filled',
    ref,
    icon: element,
  },
));

WorkHistoryFilledIcon.displayName = 'WorkHistoryFilledIcon';

export default WorkHistoryFilledIcon;
